import httpStore from "@/api/httpStore.js";

export function getUploadedFiles(filters) {
  return httpStore
    .get(`/upload`, { params: filters })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getUploadOptions() {
  return [
    {
      label: "Applications - Fitment",
      value: "applications_insert",
      enabled: true,
      description: "Use this report to create new applications."
    },
    {
      label: "Applications - ACES fitment",
      value: "applications_fitment",
      enabled: true,
      description:
        "Applications by year from an ACES file (.xlsx workbook or .csv). One row per unificado + vehicle year. Required columns: <label style='color:red; font-weight: 800;'>unificado, make, model, year, fuel_type</label>. Optional: engine, position, qty, notes, source_detail. Vehicles not found are created. Products not in the file are not touched.",
      otherOptions: [
        {
          label: "Sheet name (empty = ACES_Expanded)",
          inputType: "text",
          inputId: "sheet_name"
        },
        {
          label: "Delete current applications of the products in the file",
          inputType: "select",
          inputId: "delete_existing",
          options: [
            {
              label: "No, only add",
              value: "no"
            },
            {
              label: "Yes, replace them with the file",
              value: "yes"
            }
          ]
        },
        {
          label: "Create vehicles not found",
          inputType: "select",
          inputId: "create_vehicles",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No, report them",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Assets",
      value: "assets",
      enabled: false,
      description: "Upload any type of assets",
      otherOptions: [
        {
          label: "Asset Type",
          inputType: "select",
          inputId: "assetsType",
          options: [
            {
              label: "Product Image",
              value: "image_product"
            },
            {
              label: "Banner Image",
              value: "image_banner"
            },
            {
              label: "Category Image",
              value: "image_category"
            }
          ]
        }
      ]
    },
    {
      label: "Average shipping price",
      value: "update_average_shipping_price",
      enabled: true,
      description: "Update in bulk average shipping price"
    },
    {
      label: "Bulk Product Create",
      value: "bulk_product_create",
      enabled: true,
      description:
        "Upload a CSV or XLSX to create new products in bulk. Columns: nkr_code (optional, can be generated), brand, description, oe, origin, presentation, list_price, cost, weight, length, height, width. After uploading you will be able to review, edit rows, generate nkr_codes and commit."
    },
    {
      label: "Brands Bulk update",
      value: "brand_updates",
      enabled: true,
      description:
        "This will use brand Principal Name to update or add the other fields"
    },
    {
      label: "Activate products for store",
      value: "activate_products_store",
      enabled: true,
      description:
        "Enables a list of nkr_codes for this store (activates them same as toggling the product's store status). Required column: nkr_code. It will look up the product in the full catalog, so it works even for codes not yet enabled here."
    },
    {
      label: "Deactivate products for store",
      value: "deactivate_products_store",
      enabled: true,
      description:
        "Disables a list of nkr_codes for this store (deactivates them same as toggling the product's store status). Required column: nkr_code. It will look up the product in the full catalog, so it works even for codes not yet enabled here."
    },
    {
      label: "Categorize items",
      value: "categorize_items",
      enabled: true,
      description:
        "This function adds categories and subcategories to products. It will add the categories if the category exists only. Required columns: nkr_code, category_url, sub_category_url (matched by url, one subcategory each). Optional extra column: market — 'Market' is a fixed category and this column holds one or more subcategory URLs separated by comma; a relation is inserted for each one under the Market category."
    },
    {
      label: "Categorize items by ID",
      value: "categorize_items_by_id",
      enabled: true,
      description:
        "This function assigns a subcategory to products directly by its ID (no need for category/subcategory URLs). Required columns: nkr_code, sub_category_id"
    },
    {
      label: "Costs",
      value: "cost",
      enabled: true,
      description:
        "Add costs to items. Optional columns: cost, costo_referencial"
    },
    {
      label: "Catalog dependency (B2/Z)",
      value: "set_dependencia",
      enabled: true,
      description:
        "Assign dependency B2 or Z to a list of products. Required column: <label style='color:red; font-weight: 800;'>code</label>. These products use catalog pricing (Settings => Catalog Pricing).",
      otherOptions: [
        {
          label: "Dependency",
          inputType: "select",
          inputId: "dependencia",
          options: [
            {
              label: "B2",
              value: "B2"
            },
            {
              label: "Z",
              value: "Z"
            }
          ]
        }
      ]
    },
    {
      label: "Create customers",
      value: "create_customers",
      enabled: true,
      description: "This will create customers not found by email or rif-cedula"
    },
    {
      label: "Ebay Upload Store Category",
      value: "ebay_store_category",
      enabled: true,
      description:
        "Agrega a la categoria el ID asignado en la tienda de Ebay, cada categoria creada en ebay genera un id, este id lo debemos tener en nuestras categorias para poder agregarlo correctamente a los productos en bulk"
    },
    {
      label: "Find codes",
      value: "find_codes",
      enabled: true,
      description:
        "Find codes in file, csv or excel. It will return a file with the codes found and not found.",
      otherOptions: [
        {
          label: "code separator",
          inputType: "text",
          inputId: "code_separator"
        },
        {
          label: "Hide not found",
          inputType: "select",
          inputId: "hide_not_found",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Filter by brand",
          inputType: "select",
          inputId: "filter_by_brand",
          options: [
            {
              label: "All Brands",
              value: ""
            },
            {
              label: "Isuzu",
              value: "isuzu"
            }
          ]
        }
      ]
    },
    {
      label: "Get prices and stock quote",
      value: "prices_and_stock_quote",
      enabled: true,
      description: "From a list of nkr codes get all price levels and stock"
    },
    {
      label: "ISUZU prices match",
      value: "isuzu_prices_finder",
      enabled: true,
      description:
        "Find prices from isuzu list, it will try to match Fleet value codes first and then it will try to match any isuzu code including supersession",
      otherOptions: [
        {
          label: "Hide not found",
          inputType: "select",
          inputId: "hide_not_found",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Keywords by product",
      value: "keywords_products",
      enabled: true,
      description:
        "Adds 'description' as a search keyword for the nkr_code, it does NOT update the title (not visible on the product page, only for search matching). Columns: nkr_code, description"
    },
    {
      label: "Kit master*",
      value: "kit_master",
      enabled: true,
      description:
        "This upload will add new kits with items on it. it should containt items by line and it will create the kit and add all parts. if one part is not valid the whole kit wont be added."
    },
    {
      label: "Marketplace weight update",
      value: "marketplace_weight",
      enabled: true,
      description: "Upload the weight for marketplace calculation"
    },
    {
      label: "Marketplaces - Amazon check",
      value: "amazon_verificator",
      enabled: true,
      description:
        "Download report of active items from Amazon and upload it here. This will create the AISIN codes on the marketplaces area for the single product Inventory => Inventory Reports => All Listings Report (Custom)",
      otherOptions: [
        {
          label: "Delete products not in file",
          inputType: "select",
          inputId: "deleteNotInAmazon",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Marketplaces - Ebay check",
      value: "ebay_verificator",
      enabled: true,
      description:
        "Download report of active items from ebay upload it here. This will create the ebayID codes on the marketplaces area for the single product https://www.ebay.com/sh/reports/downloads. Source => listings, type => all active listings",
      otherOptions: [
        {
          label: "Delete products not in file",
          inputType: "select",
          inputId: "deleteNotInEbay",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Part info - INFOAUTO",
      value: "part_info_infoauto",
      enabled: true,
      description:
        "This is the export file from infoauto, it will include stock and prices"
    },
    {
      label: "Test parts list",
      value: "test_parts_list",
      enabled: true,
      description:
        "This Will verify what parts are not enabled to this store and also will show a report with the products that can't be added to the Main database (main db verification is not ready)"
    },
    {
      label: "Titles",
      value: "titles",
      enabled: true,
      description:
        "This upload will add and update titles and std_titles, requires: <label style='color:red; font-weight: 800;'>code,title,title_std,title_alt</label>. if any value is empty it won't be updated."
    },
    {
      label: "Vehicles Bulk update",
      value: "vehicles_updates",
      enabled: true,
      description:
        "This will create vehicles not found. Required columns: <label style='color:red; font-weight: 800;'>year, make, model, aspiration, cylinders, block_type, liter, engine_name, region</label>"
    },
    {
      label: "Vehicle Families Bulk update",
      value: "vehicle_families_updates",
      enabled: true,
      description:
        "This will create vehicle families not found. (catalog code, serie, family name )"
    },
    {
      value: "vehicle_catalog_code_assignment",
      label: "Vehicle catalog-family  assignment",
      enabled: true,
      description:
        "This will assign the vehicle to the family. It requires the catalog code and the vehicle id or name (vehicle_id, catalog_code)"
    },
    {
      label: "Warehouse parts allocation",
      value: "warehouse_allocation",
      enabled: true,
      description: "(sku,location)"
    },
    {
      label: "Weight and dimensions",
      value: "weight_and_dimensions",
      enabled: true,
      description:
        "Upload weight and dimensions (weight, width, length, height)"
    }
  ];
}

export function uploadFileService(files, formValues, step) {
  const formData = new FormData();
  files.forEach(file => {
    formData.append("file[]", file);
  });
  formData.append("values", JSON.stringify(formValues));
  formData.append("step", JSON.stringify(step));
  return httpStore
    .post("upload", formData)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function uploadFileServiceMatch(uploadedFile, match, step) {
  const params = {
    uploadedFile: uploadedFile,
    match: match,
    step: step
  };
  return httpStore
    .post(`upload`, params)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getUploadedFileInfo(uploadId) {
  return httpStore
    .get(`upload/info/${uploadId}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export async function signAndDownloadFile(fileKey, s3Url = null) {
  const signedRoute = await httpStore
    .get(`upload/sign?filename=${fileKey}&s3url=${s3Url}`)
    .then(res => res.data)
    .catch(() => {
      return false;
    });
  console.log("signedRoute", signedRoute);
  if (!signedRoute || !signedRoute.url) {
    return false;
  }
  console.log(signedRoute);
  window.open(signedRoute.url, "_blank");
  return true;
}

export function getFilesUploaded(category, subcategory) {
  return httpStore
    .get(`upload/files/${category}/${subcategory}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
